module.exports = __webpack_public_path__ + "static/key-quarantine-8b830a1cdd6f38529ddff5cc391dc16a.webp";